<div class="section">

       <!-- header section -->
       <div class="header-container">
        <div class="col-lg-12 col-md-12 col-sm-12 pad0 row">
            <div class="col-lg-4 col-md-4 col-sm-4 padL10">
                <div class="admin-name">Administrating Discrepancies</div>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 pad0" align="right">
                <div class="navItems">
                    <span class="headerLink">
                        <a routerLink="/search-discrep" routerLinkActive="active" class="navLink">DISCREPANCY
                            SEARCH</a>
                    </span>
                    <span class="headerLogoutLink">
                        <a class="navLink" (click)="logout()">LOGOUT</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <hr>

    <!-- Alert Message -->
    <div class="alert alert-warning" role="alert" *ngIf="DRalertMsg">{{DRalertMsg}}</div>
    <div class="alert alert-warning" role="alert" *ngIf="valErrorTopMsg">{{valErrorTopMsg}}</div>

    <!-- header -->
    <div class="headerAlign">
        <div class="header-design col-lg-6 col-md-6 col-sm-6 pad-L0">{{headerDisplay}}</div>
    </div>
    <!-- Input Fields -->
    <div class="fields-container">
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0 row">
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L10">
                <div>
                    <label class="label-view">Discrepancy ID</label>
                    <input type="text" name="disID" class="form-control" [(ngModel)]="disId" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Open Days</label>
                    <input type="text" name="opendays" class="form-control" [(ngModel)]="openDays"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Paragraph Number</label>
                    <input type="text" name="parano" class="form-control " [(ngModel)]="paraNo" [readonly]="isReadOnly">
                </div>
                <div class="newRow">
                    <Span class="checkLeft">
                        <label class="label-view">ENG</label>
                        <input type="text" name="ENG" class="form-control" [(ngModel)]="eng" [readonly]="isReadOnly">
                    </Span>
                    <span class="checkRight">
                        <label class="label-view">DR Status</label>&nbsp;<span class="mandatory">*</span>
                        <select class="form-select" [(ngModel)]="DrStatus" name="drstatuslist"
                            (change)="onChangeStatus(DrStatus)">
                            <option value="status" disabled>Select Status</option>
                            <option *ngFor='let option of drStatusData' [ngValue]="option.statusid">
                                {{option.statusdesc}}
                            </option>
                        </select>
                    </span>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">Original DR Category</label>
                    <input type="text" name="DRCat" class="form-control" [(ngModel)]="drCat" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">First Updated Date</label>
                    <input type="text" name="firstUD" class="form-control" [(ngModel)]="frstUDdate"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Table Number</label>
                    <input type="text" name="tableno" class="form-control" [(ngModel)]="tableNo"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20" *ngIf="isOther">
                    <label class="label-view">Other</label>
                    <input type="text" name="catOther" class="form-control" autocomplete="off"
                        placeholder="Type here..." [(ngModel)]="other" [maxLength]="otherLen" 
                        [ngStyle]="{'border': valTopError ? '1px solid red' : '1px solid #ccc'  }"
                        (keypress)="onKeyPressEvent($event, 'Others')">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">Open Date</label>
                    <input type="text" name="opnDate" class="form-control" [(ngModel)]="opendate"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Customer Notify Date</label>
                    <input type="text" name="custNotifDate" class="form-control" [(ngModel)]="custNotifyDate"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Figure Number</label>
                    <input type="text" name="figno" class="form-control" [(ngModel)]="figNo" [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0 pad-R0">
                <div>
                    <label class="label-view">Closed Date</label>
                    <input type="text" name="closdDate" class="form-control" [(ngModel)]="closeddate"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Page Number</label>
                    <input type="text" name="pageno" class="form-control" [(ngModel)]="pageNo" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Current DR Category</label>&nbsp;<span class="mandatory">*</span>
                    <select class="form-select" [(ngModel)]="currDrCat" name="drcatelist"
                        (change)="onSelectDRCategory(currDrCat)">
                        <option value="cateDr" disabled>Select Category</option>
                        <option *ngFor='let option of drCatData' [ngValue]="option.id">{{option.description}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0">
            <label class="label-view">Reporting Party Comment</label>
            <textarea class="form-control" rows="4" [(ngModel)]="comment" [readonly]="isReadOnly"></textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0 row">
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L10">
                <div>
                    <label class="label-view">User ID</label>
                    <input type="text" name="usrID" class="form-control" [(ngModel)]="userID" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">User Email Address</label>
                    <input type="text" name="email" class="form-control" [(ngModel)]="userEmail"
                        [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">User UUID</label>
                    <input type="text" name="uuid" class="form-control" [(ngModel)]="usrUUID" [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">User Name</label>
                    <input type="text" name="fullname" class="form-control" [(ngModel)]="usrFullName"
                        [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0 pad-R0">
                <div>
                    <label class="label-view">User Company Name</label>
                    <input type="text" name="usrcomp" class="form-control" [(ngModel)]="useCompany"
                        [readonly]="isReadOnly">
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0 row">
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L10">
                <div>
                    <label class="label-view">Pub Number</label>
                    <input type="text" name="pub" class="form-control" [(ngModel)]="pubNo" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Current Revision</label>
                    <input type="text" name="cRev" class="form-control" [(ngModel)]="currentRev"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Publication Status</label>
                    <input type="text" name="pubstatus" class="form-control" [(ngModel)]="pubStatus"
                        [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">Volume</label>
                    <input type="text" name="vol" class="form-control" [(ngModel)]="volume" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Original Revision</label>
                    <input type="text" name="orgRevision" class="form-control" [(ngModel)]="orgRev"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Export Code</label>
                    <input type="text" name="expcode" class="form-control" [(ngModel)]="expotCode"
                        [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">ATA</label>
                    <input type="text" name="ATA" class="form-control" [(ngModel)]="ata" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Organization</label>
                    <input type="text" name="organiz" class="form-control" [(ngModel)]="pubOrg" [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">License</label>
                    <input type="text" name="lic" class="form-control" [(ngModel)]="pubLic" [readonly]="isReadOnly">
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 pad-L0">
                <div>
                    <label class="label-view">Revision Date</label>
                    <input type="text" name="revisnDate" class="form-control" [(ngModel)]="revisionDate"
                        [readonly]="isReadOnly">
                </div>
                <div class="mar-T20">
                    <label class="label-view">Publication Type</label>
                    <input type="text" name="pubtype" class="form-control" [(ngModel)]="pubType"
                        [readonly]="isReadOnly">
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0">
            <label class="label-view">Closing Response</label>
            <textarea class="form-control" rows="4" placeholder="Enter Closing Response" [(ngModel)]="closeRes"
                [maxLength]="responsLen" [readonly]="isDRStatus" 
                [ngStyle]="{'border': valBottomError ? '1px solid red' : '1px solid #ccc'  }"
                (keypress)="onKeyPressEvent($event, 'CloseRes')"></textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mar-T20 pad-L0 pad-R0" align="center">
            <!-- Alert Message -->
            <div class="alert alert-warning" role="alert" *ngIf="valErrorBottomMsg">{{valErrorBottomMsg}}</div>
            <div class="alert alert-warning" role="alert" *ngIf="DRWarnMsg">{{DRWarnMsg}}</div>
            <div class="successAlert" *ngIf="dr_dtl_succss">{{dr_dtl_succss}}</div>
            <button type="button" (click)="DRDetail()" [disabled]="!validationFields()"
                [ngClass]="!validationFields() ? 'btn DR_Dt_btn btn-gray-cls ' : 'btn DR_Dt_btn btn-blue-cls hover'">Save</button>
        </div>
    </div>
</div>